import styled, { css } from 'styled-components';

import Link from '@bitcoin-portal/verse-web-components/dist/Link';
import { media } from '@bitcoin-portal/verse-web-components/dist/themes/breakpoints';
import { colors } from '@bitcoin-portal/verse-web-components/dist/themes/colors';

import { tabletBreakpoints } from '@context/constants';

export const Wrapper = styled.div`
  width: 100%;
  display: flex;
  flex-flow: column nowrap;
  border-top: 1px solid ${colors.shade30};

  &:not(:first-child),
  &:only-child {
    border-bottom: 1px solid ${colors.shade30};
  }

  ${media.sm`
    border-radius: 23px;
    border: 1px solid ${colors.shade30};
  `}
`;

export const Banner = styled.div`
  box-shadow: none;
  margin: auto;
  width: 100%;
  height: 130px;
  position: relative;
  background-image: url('/images/uploads/farms-banner-bg3.png');
  background-position: right;
  background-repeat: no-repeat;
  background-size: cover;
  box-sizing: border-box;

  @media (min-width: 320px) {
    width: 100%;
  }

  ${media.sm`
      max-width: 600px;
      border-radius: 23px;
      background-position: 0px center;
  `}

  @media (min-width: ${tabletBreakpoints.xlarge}) {
    box-shadow: rgba(47, 169, 238, 0.2) 0px 2px 60px 0px;
  }
`;

export const StyledLink = styled(Link)`
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
`;

export const Content = styled.div`
  ${({ theme }) => css`
    padding: 24px 150px 24px 24px;

    & > div:last-child {
      margin-top: ${theme.spacing.unit * 4}px;
    }

    & > h3 {
      font-size: 18px;
    }

    ${media.sm`
      padding-right: 80px;
      max-width: 240px;

      & > h3 {
        font-size: 24px;
      }
    `}
  `}
`;

export const ButtonWrapper = styled.div`
  & > div {
    height: 24px;
    font-size: 12px;
  }
`;
